import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import {
  IconArrowBigUpFilled,
  IconFileInvoice,
  IconKey,
} from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const WITHDRAW_BTC_CONTENT = (
  <TypographyStylesProvider>
    <p>You can withdraw BTC with a button that looks like this:</p>

    <DocsButton
      ariaLabel="deposit btc"
      text="Withdraw BTC"
      leftSection={<IconArrowBigUpFilled />}
    />

    <p>
      You're going to want to be really careful on this screen. Remember --
      there are "no refunds" for Bitcoin transactions. Make sure you've read and
      understand our{" "}
      <a href="/safety" target="_blank">
        {" "}
        safety documentation
      </a>
      .
    </p>

    <SimpleImage h={400} src="docs_images/withdraw-btc-onchain.png" />
    <p>
      The key to efficient on-chain BTC transactions comes down to two words:
      "Be patient".
    </p>
    <p>
      Fee spikes do happen, and they are hard to predict, and although it is
      possible to increase the fee of your payment AFTER you send it, that is
      never cheap, and we've really found that the best strategy is just to
      assume that the transaction might take an hour or so.
    </p>

    <p>
      So, as you might expect, you can start by entering the amount you want to
      send in <strong>Satoshis</strong> into the box.{" "}
    </p>

    <p>
      {" "}
      If you type an arbitrarily high number, close to or above the total amount
      of BTC on your node, you will see a warning like this:
    </p>

    <SimpleImage h={250} src="docs_images/sending-too-much-satoshis2.png" />
    <p>This can be confusing, so let's break it down.</p>

    <p>
      First of all, you should know that, at the time we took this screenshot,
      Rizful Node$1 we had about 30,000 satoshis on our node (a very small
      amount). And Rizful is complaining because we were trying to send an
      amount over 20,821 satoshis. Basically: Not only can you not send more
      than you have, but also, we don't want you leaving tiny balances on your
      node. You can definitely leave a zero (0) balance on your node, but not a
      tiny balance of 1,000 or 5,000 satoshis.
    </p>

    <p>
      We're doing this to protect you from something called "un-economical
      transactions." You see, if Rizful Node had allowed us to withdraw 25,000
      satoshis, then we would have had 5,000 satoshis left over on the node.
    </p>
    <p>
      That might seem fine, but remember, when you send BTC payments, you need
      to pay FEES. And those fees, for just one transaction, under certain
      conditions, might be 1,000 or even 10,000 satoshis!{" "}
    </p>
    <p>
      This (by the way), is the reason that we like to use Lightning for BTC
      payments, and not the BTC network directly.
    </p>
    <p>
      Anyway, there is a great solution -- just assume that you will never leave
      tiny balances on your node, and use the <strong>Send All Funds</strong>{" "}
      checkbox at the point that you want to fully withdraw on your node.
    </p>
    <h4>But what doese the "Send All Funds" checkbox do? </h4>
    <p>
      It's simple. If you check the "Send All Funds" box, Rizful Node will try
      to choose the perfect amount to send, and the perfect amount to reserve
      for fees, so that you can effectively withdraw your entire BTC balance,
      and not leave a tiny balance on your node.
    </p>

    <p>
      {" "}
      One more thing. If the <strong>fee estimate</strong> seems too high, take
      a look at
      <a href="https://mempool.space/" target="_blank">
        {" "}
        Mempool.space
      </a>{" "}
      to see what the current fee rates are. If you can be patient, it might be
      a good idea to come back later, and try again when fee rates are lower.{" "}
    </p>
  </TypographyStylesProvider>
);
